// src/hooks/useAuth.ts
import { useState, useEffect } from "react";
import { authService } from "../services/authService";
import { config } from "../config/config";

export const useAuth = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const checkAuth = async () => {
    setIsLoading(true);
    try {
      const user_data = await authService.fetchMe();
      console.log("[Auth] User metadata from SSO:", user_data);
      if (user_data?.email) {
        authService.setAuthData({
          user_id: user_data.user_id,
          email: user_data.email,
          user_info: user_data,
        });
        setIsAuthenticated(true);
      }
    } catch (err) {
      console.error("[Auth] Error checking auth:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated === false || authService.isAuthenticated() === false) {
      checkAuth();
    }
  }, [isAuthenticated]);

  const logout = () => {
    authService.clearAuthData();
    setIsAuthenticated(false);
    window.location.href = config.signOutUrl;
  };

  return { isAuthenticated, logout, isLoading };
};
